import { CheckIcon, DownloadIcon, ListIcon, Loader2Icon, LogInIcon, LogOutIcon, RepeatIcon, Share2Icon, SkipBackIcon, SkipForwardIcon, Volume1Icon, Volume2Icon, VolumeIcon, VolumeXIcon, XIcon } from 'lucide-react';
export const icons = {
  auth: {
    login: LogInIcon,
    logout: LogOutIcon
  },
  library: {
    download: DownloadIcon
  },
  share: Share2Icon,
  player: {
    list: ListIcon,
    repeat: RepeatIcon,
    skipBack: SkipBackIcon,
    skipForward: SkipForwardIcon,
    volume: {
      mute: VolumeXIcon,
      low: Volume1Icon,
      medium: Volume2Icon,
      high: VolumeIcon
    }
  },
  state: {
    success: CheckIcon,
    error: XIcon,
    loading: Loader2Icon
  }
} as const;